import actions from "./action";

const { ASSIGNED_USER_TOPICS_BEGIN, ASSIGNED_USER_TOPICS_SUCCESS, ASSIGNED_USER_TOPICS_ERR } = actions

const initState = {
  loading: false,
  data: {
    assignedUserTopics: []
  },
};

const AssignedUserTopicsReducer = (state = initState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case ASSIGNED_USER_TOPICS_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case ASSIGNED_USER_TOPICS_SUCCESS:
      return {
        ...state,
        data,
        loading: false,
      };
    case ASSIGNED_USER_TOPICS_ERR:
      return {
        ...state,
        err,
        loading: false,
      };
      default:
      return state;
    }
  };

  export default AssignedUserTopicsReducer